'use client'

import { addStaticTextTranslations } from '@/lib/translation/i18n'
import { ReactNode } from 'react'

interface StaticTextsProviderProps {
  language: string
  translations?: Record<string, string>
  children: ReactNode
}

export function StaticTextsProvider({ language, translations, children }: Readonly<StaticTextsProviderProps>) {
  if (translations) {
    addStaticTextTranslations(language, translations)
  }

  return <>{children}</>
}
